import defer from "lodash/defer";
import uniqueId from "lodash/uniqueId";
import { ChangeEvent } from "react";
import { ControlProps, RadioGroupItem } from "types";
import "./radio-group-control.scss";

interface RadioGroupControlProps extends Omit<ControlProps, "label"> {
	items: RadioGroupItem[];
	onChange?: (value: string) => void;
	label?: string;
}

const RadioGroupControl = (props: RadioGroupControlProps) => {
	const { register } = props.formMethods ?? {};
	const registerOuput = register!(props.name);

	const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
		if (props.onChange && e.target.checked) {
			defer(props.onChange, e.target.value);
		}
		return registerOuput.onChange(e);
	};

	return (
		<div className="form-radio-group mb-2">
			<label htmlFor={props.name} className="">{props.label && `${props.label}:`}</label>
			<div className=" row col-sm-12">
				{props.items.map((item, i) => {
					const id = uniqueId('prefix-radio');
					return (
						<div key={i} className="form-check-inline">
							<input
								{...registerOuput}
								id={id}
								type="radio"
								tabIndex={props.tabIndex}
								value={item.value}
								onChange={changeHandler}
							/>
							<label className="form-check-label" htmlFor={id}>{item.label}</label>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default RadioGroupControl;